module.exports = __webpack_public_path__ + "img/topic_list_icon.e546262a.svg";